import { stpFutureValue } from "../../engine/calculations";
import { currencyAxis, monthsAxis } from "./reckonerAxes";

const config = {
  key: "rr-stp-fv",
  title: "STP Future Value Ready Reckoner",
  category: "Ready Reckoners",
  description: "See the target-fund value of a Systematic Transfer Plan across transfer amounts and durations.",
  reckoner: true,
  rowAxis: currencyAxis("Monthly Transfer", [10_000, 20_000, 30_000, 40_000, 50_000]),
  colAxis: monthsAxis("Months", [12, 24, 36, 48, 60]),
  extraFields: [
    { key: "sourceCorpus", label: "Source corpus", type: "currency", default: 20_00_000, min: 1000, max: 10_00_00_000 },
    { key: "sourceRate", label: "Source fund return", type: "percent", default: 7, min: 0, max: 20, assumptionKey: "debtReturn" },
    { key: "targetRate", label: "Target fund return", type: "percent", default: 12, min: 0, max: 30, assumptionKey: "equityReturn" },
  ],
  computeCell(transfer, months, extra) {
    const sourceCorpus = Number(extra.sourceCorpus) || 0;
    const sourceRate = (Number(extra.sourceRate) || 0) / 100;
    const targetRate = (Number(extra.targetRate) || 0) / 100;
    return stpFutureValue(sourceCorpus, sourceRate, targetRate, transfer, months).finalTarget;
  },
};

export default config;
